<template>
  <div class="intro-dialog" id="introDialog" v-if="posts.length">
    <!-- Modal -->
    <div
      class="modal fade"
      id="introDialogModal"
      tabindex="-1"
      aria-labelledby="introDialogModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <!-- <div v-if="post.body" v-html="post.body"></div> -->
            <Swiper
              class="swiper--intro-dialog"
              :modules="[SwiperNavigation]"
              :navigation="{
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              }"
              :allowTouchMove="true"
              :spaceBetween="24"
              :breakpoints="{
                920: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                },
                320: {
                  slidesPerView: 1,
                  spaceBetween: 10,
                },
              }"
            >
              <SwiperSlide
                class="swiper-slide--custom"
                v-for="post in posts"
                :key="post.id"
              >
                <!-- <img :src="slide.path" :alt="slide.caption" /> -->
                <div v-if="post.body" v-html="post.body"></div>
              </SwiperSlide>

              <div class="swiper-navigation">
                <div class="swiper-button-prev"></div>
                <div class="swiper-button-next"></div>
              </div>
            </Swiper>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

const { posts } = defineProps(['posts'])

onMounted(async () => {

  if (posts.length > 0) {
    const { Modal } = await import("bootstrap");
    const modalElement = document.getElementById("introDialogModal");

    if (modalElement) {
      const flashModal = new Modal(modalElement, {
        keyboard: false,
      });
      flashModal.show(); // Show modal on page load
    }
  }
});
</script>

<style lang="scss" scoped>
.modal-dialog {
  .modal-header {
    padding: 0 10px;
    border-bottom: 0;
    .btn-close {
      background-color: white;
      border-radius: 50%;
    }
  }
  .modal-content {
    background-color: transparent;
    border-radius: 0;
    border: 0;
  }
  .modal-body {
    padding: 15px 20px;
  }
}
</style>